import {Action, createFeatureSelector, createSelector} from '@ngrx/store';
import {ofType} from '@ngrx/effects';
import {catchError, delay, exhaustMap, map, mergeMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {BackendService} from './services/backend.service';
import {AuthActionTypes} from './auth/store/auth.actions';
import * as _ from 'lodash';

export namespace CoreStore {

    export interface ActionTypes {
        Set: string;
        MergeData: string;

        Success : string;
        Failure : string;

        Load : string;
        LoadSuccess : string;
        LoadFailure : string;

        Create : string;
        CreateSuccess : string;
        CreateFailure : string;

        Delete : string;
        DeleteSuccess : string;
        DeleteFailure : string;

        DeleteMultiple : string;

        Update : string;
        UpdateSuccess : string;
        UpdateFailure : string;

        Paste : string;
        PasteSuccess : string;
        PasteFailure : string;

        Move : string;

        CreateShare : string;
        CreateShareSuccess : string;
    }

    export function baseActionTypesBuilder(featureName): ActionTypes {
        return <ActionTypes> {
            Set: `[${featureName}]` + " Set",
            MergeData: `[${featureName}]` + " MergeData",

            Success : `[${featureName}]` + " Success",
            Failure : `[${featureName}]` + " Failure",

            Load : `[${featureName}]` + ' Load',
            LoadSuccess : `[${featureName}]` + ' Load Success',
            LoadFailure : `[${featureName}]` + ' Load Failure',

            Create : `[${featureName}]` + ' Create',
            CreateSuccess : `[${featureName}]` + ' Create Success',
            CreateFailure : `[${featureName}]` + ' Create Failure',

            Delete : `[${featureName}]` + ' Delete',
            DeleteSuccess : `[${featureName}]` + ' Delete Success',
            DeleteFailure : `[${featureName}]` + ' Delete Failure',

            DeleteMultiple : `[${featureName}]` + ' Delete Multiple',

            Update : `[${featureName}]` + ' Update',
            UpdateSuccess : `[${featureName}]` + ' Update Success',
            UpdateFailure : `[${featureName}]` + ' Update Failure',

            Paste : `[${featureName}]` + ' Paste',
            PasteSuccess : `[${featureName}]` + ' Paste Success',
            PasteFailure : `[${featureName}]` + ' Paste Failure',

            Move : `[${featureName}]` + ' Move',

            CreateShare : `[${featureName}]` + ' CreateShare',
            CreateShareSuccess : `[${featureName}]` + ' CreateShareSuccess'
        }
    }

    export class Actions {
        Set: any;
        MergeData: any;

        Success : any;
        Failure : any;

        Load : any;
        LoadSuccess : any;
        LoadFailure : any;

        Create : any;
        CreateSuccess : any;
        CreateFailure : any;

        Delete : any;
        DeleteSuccess : any;
        DeleteFailure : any;

        DeleteMultiple : any;

        Update : any;
        UpdateSuccess : any;
        UpdateFailure : any;

        Paste : any;
        PasteSuccess : any;
        PasteFailure : any;

        Move : any;

        CreateShare : any;
        CreateShareSuccess : any;

        ActionsUnion: any;

        protected readonly FEATURE_NAME: string;
        protected _types: ActionTypes | any = {};

        constructor(featureName: string){
            this.FEATURE_NAME  = featureName;
            this._types        = {
                ...this._types,
                ...baseActionTypesBuilder(featureName)
            };
            this._actionClassBuilder(baseActionTypesBuilder(featureName));
        }

        get Types(): ActionTypes | any {
            return this._types
        }

        private _actionClassBuilder(actionTypes: ActionTypes) {

            this.Load = class implements Action {
                public readonly type = actionTypes.Load;
                constructor(public payload: any) {}
            };
            this.LoadSuccess = class implements Action {
                public readonly type = actionTypes.LoadSuccess;
                constructor(public payload: any) {}
            };
            this.LoadFailure = class implements Action {
                public readonly type = actionTypes.LoadFailure;
                constructor(public payload: any) {}
            };
            this.Create = class implements Action {
                public readonly type = actionTypes.Create;
                constructor(public payload: any) {}
            };
            this.CreateSuccess = class implements Action {
                public readonly type = actionTypes.CreateSuccess;
                constructor(public payload: any) {}
            };
            this.CreateFailure = class implements Action {
                public readonly type = actionTypes.CreateFailure;
                constructor(public payload: any) {}
            };
            this.Update = class implements Action {
                public readonly type = actionTypes.Update;
                constructor(public payload: any) {}
            };
            this.UpdateSuccess = class implements Action {
                public readonly type = actionTypes.UpdateSuccess;
                constructor(public payload: any) {}
            };
            this.UpdateFailure = class implements Action {
                public readonly type = actionTypes.UpdateFailure;
                constructor(public payload: any) {}
            };
            this.Paste = class implements Action {
                public readonly type = actionTypes.Paste;
                constructor(public payload: any) {}
            };
            this.PasteSuccess = class implements Action {
                public readonly type = actionTypes.PasteSuccess;
                constructor(public payload: any) {}
            };
            this.PasteFailure = class implements Action {
                public readonly type = actionTypes.PasteFailure;
                constructor(public payload: any) {}
            };
            this.Move = class implements Action {
                public readonly type = actionTypes.Move;
                constructor(public payload: any) {}
            };
            this.CreateShare = class implements Action {
                public readonly type = actionTypes.CreateShare;
                constructor(public payload: any) {}
            };
            this.CreateShareSuccess = class implements Action {
                public readonly type = actionTypes.CreateShareSuccess;
                constructor(public payload: any) {}
            };
            this.Delete = class implements Action {
                public readonly type = actionTypes.Delete;
                constructor(public payload: any) {}
            };
            this.DeleteSuccess = class implements Action {
                public readonly type = actionTypes.DeleteSuccess;
                constructor(public payload: any) {}
            };
            this.DeleteFailure = class implements Action {
                public readonly type = actionTypes.DeleteFailure;
                constructor(public payload: any) {}
            };
            this.DeleteMultiple = class implements Action {
                public readonly type = actionTypes.DeleteMultiple;
                constructor(public payload: any) {}
            };
            this.Set = class implements Action {
                public readonly type = actionTypes.Set;
                constructor(public payload: any) {}
            };
            this.MergeData = class implements Action {
                public readonly type = actionTypes.MergeData;
                constructor(public payload: any) {}
            };

            this.Success = class implements Action {
                public readonly type = actionTypes.Success;
                constructor(public payload: any) {}
            };
            this.Failure = class implements Action {
                public readonly type = actionTypes.Failure;
                constructor(public payload: any) {}
            };

            setTimeout(( ) => {
                this.ActionsUnion =
                    this.Set | this.Success | this.Failure
                | this.Load | this.LoadSuccess | this.LoadFailure
                | this.Create | this.CreateSuccess | this.CreateFailure
                | this.Update | this.UpdateSuccess | this.UpdateFailure
                | this.Delete | this.DeleteSuccess | this.DeleteFailure
                | this.Paste | this.PasteSuccess | this.PasteFailure
                | this.Move
                | this.CreateShare | this.CreateShareSuccess
                | this.DeleteMultiple;
            });
        }

    }

    export interface EffectsOptions {
        Actions: Actions;
        FEATURE_NAME: string;
        featureService: BackendService;
        actions$: Observable<any>;
        initialState?: any;
    }

    export class Effects {

        static Load(options: EffectsOptions,
                    resourceOptionsTransform = (resource) => resource,
                    onSuccess = (requestObj, results) => results) {
            return options.actions$.pipe(
                ofType(options.Actions.Types.Load),
                map((action: any) => action.payload),
                exhaustMap((obj) =>
                    options.featureService.doLoad(resourceOptionsTransform(obj))
                        .pipe(
                            map(data => new options.Actions.LoadSuccess(onSuccess(obj, data))),
                            catchError(error => of(new options.Actions.LoadFailure(error))))
                )
            )
        }

        static Create(options: EffectsOptions,
                      resourceOptionsTransform = (resource) => resource) {
            return options.actions$.pipe(
                ofType(options.Actions.Types.Create),
                map((action: any) => action.payload),
                exhaustMap((obj) =>
                    options.featureService.doAdd(resourceOptionsTransform(obj))
                        .pipe(
                            map(data => new options.Actions.CreateSuccess(data)),
                            catchError(error => of(new options.Actions.CreateFailure(error))))
                )
            )
        }

        static Update(options: EffectsOptions,
                      resourceOptionsTransform = (resource) => resource) {
            return options.actions$.pipe(
                ofType(options.Actions.Types.Update),
                map((action: any) => action.payload),
                exhaustMap((obj) =>
                    options.featureService.doUpdate(resourceOptionsTransform(obj))
                        .pipe(
                            map(data => new options.Actions.UpdateSuccess(data)),
                            catchError(error => of(new options.Actions.UpdateFailure(error))))
                )
            )
        }

        static Delete(options: EffectsOptions,
                      resourceOptionsTransform = (resource) => resource) {
            return options.actions$.pipe(
                ofType(options.Actions.Types.Delete),
                map((action: any) => action.payload),
                exhaustMap((obj) =>
                    options.featureService.doDelete(resourceOptionsTransform(obj))
                        .pipe(
                            map(data => new options.Actions.DeleteSuccess(data)),
                            catchError(error => of(new options.Actions.DeleteFailure(error))))
                )
            )
        }

        static ActionSuccess(options: EffectsOptions) {
            return options.actions$.pipe(
                ofType
                (options.Actions.Types.CreateSuccess, options.Actions.Types.DeleteSuccess, options.Actions.Types.LoadSuccess, options.Actions.Types.UpdateSuccess),
                exhaustMap(() => of(new options.Actions.Success({})))
            )
        }

        static ActionFailure(options: EffectsOptions) {
            return options.actions$.pipe(
                ofType
                (options.Actions.Types.CreateFailure, options.Actions.Types.DeleteFailure, options.Actions.Types.LoadFailure, options.Actions.Types.UpdateFailure),
                map((action: any) => action.payload),
                mergeMap((error) =>
                    _.compact([
                        new options.Actions.Failure(error),
                        error.status === 403
                            ? { type: AuthActionTypes.Logout }
                            : false
                    ])
                )
            )
        }

        static FlushOnLogout(options: EffectsOptions){
            return options.actions$.pipe(
                ofType(AuthActionTypes.Logout),
                exhaustMap(( ) => of(new options.Actions.Set(options.initialState || initialState)))
            )
        }

        static SuccessReset(options: EffectsOptions) {
            return options.actions$.pipe(
                ofType(options.Actions.Types.Success, options.Actions.Types.Failure),
                delay(250),
                exhaustMap(() => of(new options.Actions.Set({
                    success: undefined,
                    reason: undefined
                })))
            )
        }


    }

    export class State {
        success: boolean;
        reason: string;
        selected: any;
        data: any;
    }

    export const initialState: State = {
        success: undefined,
        reason: undefined,
        selected: undefined,
        data: []
    };

    export function selectors(FEATURE_NAME) {

        const selectState = createFeatureSelector<any>(FEATURE_NAME);

        return {
            success: createSelector(selectState, (state: State) => state.success),
            data: createSelector(selectState, (state: State) => state.data),
            selected: createSelector(selectState, (state: State) => state.selected)
        }

    }

    export function reducer(state = initialState, action, FeatureActions) {
        switch (action.type) {

            case FeatureActions.Types.Set: {
                return {
                    ...state,
                    ...action.payload
                }
            }

            case FeatureActions.Types.MergeData: {
                return {
                    ...state,
                }
            }

            case FeatureActions.Types.Success: {
                return {
                    ...state,
                    success: true
                }
            }

            case FeatureActions.Types.Failure: {
                return {
                    ...state,
                    success: false,
                    reason: action.payload
                }
            }

            case FeatureActions.Types.LoadSuccess: {
                return {
                    ...state,
                    data: action.payload
                }
            }

            default: {
                return state;
            }
        }
    }

}
